import { IFilter } from '@/components/CourseFiltersDrawer/types'
import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'

export const CATALOG_LIST_FILTER = `[
  ['objectiveWorkflowAggregate.isSelfEnrolled', '<>', true],'and',
  ['objective.activity.state', '<>', 4],'and',
  ['showInCatalog', '=', true], 'and',
  ['objectiveWorkflowAggregate.lastObjectiveWorkflow.id', '=', null], 'and',
  ['objectiveWorkflowAggregate.lastObjectiveRecord.id', '=', null]
]`

export const useGetCatalogCoursesFilter = () => {
  const catalogCoursesSearchText = useAppSelector((state) => state.aggregates.catalogCoursesSearchText)
  const filters = useAppSelector((state) => createFiltersSelector(state, 'catalog'))

  const getSearchFilter = (text: string): string => {
    if (!text) return ''

    return `[
      ["objective.code", "contains", "${text}"], "or",
      ["objective.name", "contains", "${text}"], "or",
      ["objective.description", "contains", "${text}"]
    ]`
  }

  const buildFilter = (filters: IFilter): string => {
    const buildTermFilter = (term: string): string => `["termId", "=", "${term}"]`

    const buildFilters = (queries: string[]): string =>
      queries
        .filter(Boolean)
        .map((filter, index, array) => (index === array.length - 1 ? `${filter}` : `${filter}, "or"`))
        .join(', ')

    const termFilters = buildFilters(filters.term.map(buildTermFilter))

    const combinedFilters = [termFilters]
      .filter(Boolean)
      .map((filter, index, array) => (index === array.length - 1 ? `[${filter}]` : `[${filter}], "and"`))

    return combinedFilters.join(', ')
  }

  const searchFilter = getSearchFilter(catalogCoursesSearchText)
  const filtersQuery = buildFilter(filters)

  const finalFilter = [searchFilter, CATALOG_LIST_FILTER, filtersQuery].filter(Boolean).join(', "and", ')

  return `[${finalFilter}]`
}
